import { ChangeDetectionStrategy, Component } from '@angular/core';

import { FormManagerService } from '@sim/form';
import { BaseFiltersComponent, FilterFieldsOptions } from '@ui/ui.module';

import { cardF } from '@atmi/core/models';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-card-f-filters',
  styleUrls: ['./card-f-filters.component.scss'],
  templateUrl: './card-f-filters.component.html',
})
export class CardFFiltersComponent extends BaseFiltersComponent<cardF.CardFFilter, FilterFieldsOptions<cardF.CardFFilter>> {
  constructor(
    protected readonly formManager: FormManagerService,
  ) {
    super(formManager, cardF.CardFFiltersMeta);
  }
}
